/* The one door to the development fixtures, and it is bolted shut in a build.
 *
 * TWO CONDITIONS, both required:
 *
 *   import.meta.env.DEV        false in every `vite build`, and REPLACED at
 *                              build time — not read at runtime — so the
 *                              branch below is dead code Rollup deletes, and
 *                              the dynamic import goes with it. That is what
 *                              keeps the fixture rows out of dist/ rather
 *                              than merely unused inside it.
 *
 *   VITE_FIXTURES === "1"      explicit opt-in. A developer who has not asked
 *                              for fixtures sees the same empty and error
 *                              states a visitor sees, which is the state
 *                              worth developing against.
 *
 * Turn them on for a session with:  VITE_FIXTURES=1 npm run dev
 */
export const FIXTURES_ENABLED =
  import.meta.env.DEV && import.meta.env.VITE_FIXTURES === "1";

type DevFixtures = typeof import("./fixtures");

/** The fixtures, or null — which is every case except an opted-in dev run. */
export async function devFixtures(): Promise<DevFixtures | null> {
  if (!FIXTURES_ENABLED) return null;
  return import("./fixtures");
}
